
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import bgImage from "../assets/bg.png";
import "./Profile.css";
import { backend_url } from "../constants/backend";
import promoIcon from "../assets/profile.png";


export default function Profile() {
  const location = useLocation();

  const emailFromState = location?.state?.email || "";
  const [email, setEmail] = useState(emailFromState);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);

  const [qrImageUrl, setQrImageUrl] = useState("");
  const [promoLoading, setPromoLoading] = useState(false);

  // Full image popup
  const [showFullPhoto, setShowFullPhoto] = useState(false);
  const [showChangePhoto, setShowChangePhoto] = useState(false);
  const [newPhoto, setNewPhoto] = useState(null);
  const [uploading, setUploading] = useState(false);
  // 🎰 Casino slot display (UI only)
  // 🎰 Casino slot display (UI only)
  const [slotDigits, setSlotDigits] = useState(
    Array(7).fill("0")
  );


  // READ EMAIL FROM SESSION IF STATE IS EMPTY
  useEffect(() => {
    if (!emailFromState) {
      try {
        const stored = sessionStorage.getItem("userEmail") || "";
        setEmail(stored);
      } catch (err) {
        console.warn("sessionStorage unavailable:", err);
      }
    }
  }, [emailFromState]);



  const startSlotRoll = (finalPoints) => {
    const finalStr = String(finalPoints)
      .padStart(7, "0")
      .slice(-7);

    let interval = setInterval(() => {
      setSlotDigits(
        Array.from({ length: 7 }, () =>
          Math.floor(Math.random() * 10).toString()
        )
      );
    }, 80);

    setTimeout(() => {
      clearInterval(interval);
      setSlotDigits(finalStr.split("")); // 🎯 stop at backend score
    }, 1500);
  };


  // FETCH PROFILE FROM BACKEND
  useEffect(() => {
    if (!email) {
      setLoading(false);
      setError("No email found for profile.");
      return;
    }

    const fetchProfileData = async () => {
      try {
        setLoading(true);
        setError("");

        const resp = await fetch(`${backend_url}/profile/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });

        if (!resp.ok) {
          setError("Failed to load profile. Please try again.");
          setLoading(false);
          return;
        }

        const d = await resp.json();
        setData(d);
        startSlotRoll(d.points || 0);


        // QR GENERATION
        if (d.qr_code) {
          let finalQrUrl = "";

          if (d.qr_code.startsWith("http")) {
            finalQrUrl = d.qr_code;
          } else {
            finalQrUrl =
              "https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=" +
              encodeURIComponent(d.qr_code) +
              "&margin=20";
          }

          setQrImageUrl(finalQrUrl);
        }
      } catch (err) {
        console.error(err);
        setError("Failed to load profile. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();
  }, [email]);



  const handlePromoDownload = async () => {
    if (!data?.mobile) {
      alert("Mobile number not found");
      return;
    }

    try {
      setPromoLoading(true);

      const resp = await fetch(`${backend_url}/promo-image/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile: data.mobile }),
      });

      const result = await resp.json();

      if (!resp.ok) {
        alert(result.detail || "Promo image not found");
        return;
      }

      // Force download
      const link = document.createElement("a");
      link.href = result.download_url;
      link.download = result.file_name || "promo.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (err) {
      console.error(err);
      alert("Failed to download promo image");
    } finally {
      setPromoLoading(false);
    }
  };


  return (
    <div
      className="profile-page"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="profile-card">
        {/* Header */}
        <div className="profile-header">
          <div>
            <h1 className="profile-title">Profile Overview</h1>
            <p className="profile-subtitle">
              Here are your registered details for the event
            </p>
          </div>
        </div>

        {/* MAIN CONTENT */}
        {loading ? (
          <div className="profile-loading">
            <div className="spinner-circle"></div>
            <p className="profile-loading-text">Loading profile...</p>
          </div>
        ) : error ? (
          <div className="profile-error">{error}</div>
        ) : !data ? (
          <p className="profile-no-data">No profile data found.</p>
        ) : (
          <>
            <div className="profile-grid">
              {/* LEFT SIDE */}
              <div>
                <div className="profile-main-row">
                  {/* LEFT – PHOTO */}
                  <div className="profile-photo-container">
                    <div
                      className="profile-photo-wrapper"
                      onClick={() => {
                        if (data.photo) setShowFullPhoto(true);
                      }}
                    >
                      {data.photo ? (
                        <img
                          src={data.photo}
                          className="profile-photo"
                          alt="User profile"
                          onError={(e) => (e.target.style.display = "none")}
                        />

                      ) : (
                        <div className="profile-photo-fallback">
                          {data?.name?.[0]?.toUpperCase() || "U"}
                        </div>
                      )}
                    </div>

                    <p
                      className="change-profile-text"
                      onClick={() => setShowChangePhoto(true)}
                    >
                      Change profile
                    </p>
                  </div>

                  {/* CENTER – NAME + POINTS */}
                  <div className="profile-name-block">
                    <h2 className="profile-name">{data.name}</h2>

                    <p className="profile-role">
                      {data.company_name && " " + data.company_name}
                    </p>

                    <div className="profile-points-row">
                      {/* <p className="profile-points-pill">
        Points:{" "}
        <span className="profile-points">
          {displayPoints} 🪙
        </span>
      </p> */}

                      <button
                        className="promo-download-btn"
                        onClick={handlePromoDownload}
                        disabled={promoLoading}
                      >
                        <img
                          src={promoIcon}
                          alt="Promo"
                          className="promo-download-icon"
                        />
                        <span>
                          {promoLoading ? "Downloading..." : "Promo Download"}
                        </span>
                      </button>
                    </div>
                  </div>

                  {/* RIGHT – 🎰 CASINO SLOT UI */}
                  <div className="casino-slot-wrapper">
                    <div className="casino-slot-title">YOUR POINTS</div>
                    {/* <div className="casino-slot-sub">Watch your points roll in!</div> */}

                    <div className="casino-slot-box">
                      {slotDigits.map((digit, index) => (
                        <div key={index} className="casino-slot-column">
                          {digit}
                        </div>
                      ))}
                    </div>

                    {/* <div className="casino-slot-final">
      Points: {data.points} 🪙
    </div> */}
                  </div>
                </div>


                {/* DETAILS */}
                <div className="profile-details-card">
                  <DetailRow label="Full Name" value={data.name} />
                  <DetailRow label="Email" value={data.email} />
                  <DetailRow label="Mobile" value={data.mobile} />
                  <DetailRow label="Company" value={data.company_name} />
                  <DetailRow label="Designation" value={data.designation} />
                </div>
              </div>

              {/* RIGHT SIDE – QR */}
              <div>
                <div className="profile-qr-card">
                  <h3 className="profile-qr-title">Event QR Pass</h3>
                  <p className="profile-qr-subtitle">
                    Scan this QR at the venue to verify your registration.
                  </p>

                  {qrImageUrl ? (
                    <div className="profile-qr-wrapper">
                      <img
                        src={qrImageUrl}
                        className="profile-qr-image"
                        alt="Event QR code"
                      />

                    </div>
                  ) : (
                    <p className="profile-qr-missing">
                      QR code will be available soon.
                    </p>
                  )}

                  <p className="profile-qr-footer">
                    Keep this page handy for event entry.
                  </p>
                </div>
              </div>
            </div>

            {/* FULL PHOTO VIEW */}
            {showFullPhoto && data.photo && (
              <div
                className="profile-photo-overlay"
                onClick={() => setShowFullPhoto(false)}
              >
                <div
                  className="profile-photo-overlay-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="profile-photo-close"
                    onClick={() => setShowFullPhoto(false)}
                  >
                    ✕
                  </button>
                  <img
                    src={data.photo}
                    alt="User profile full view"
                    className="profile-photo-full"
                  />

                </div>
              </div>
            )}

            {/* CHANGE PROFILE POPUP */}
            {showChangePhoto && (
              <div className="profile-modal-overlay">
                <div className="profile-modal">
                  <h3>Change Profile Photo</h3>

                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setNewPhoto(e.target.files[0])}
                  />

                  <div className="profile-modal-actions">
                    <button
                      className="btn-cancel"
                      onClick={() => {
                        setShowChangePhoto(false);
                        setNewPhoto(null);
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn-submit"
                      disabled={!newPhoto || uploading}
                      onClick={async () => {
                        if (!newPhoto) return;

                        try {
                          setUploading(true);
                          const formData = new FormData();
                          formData.append("email", email);
                          formData.append("photo", newPhoto);

                          const res = await fetch(
                            `${backend_url}/update-profile-photo/`,
                            {
                              method: "POST",
                              body: formData,
                            }
                          );

                          const result = await res.json();

                          if (res.ok) {
                            setData((prev) => ({
                              ...prev,
                              photo: result.photo,
                            }));
                            setShowChangePhoto(false);
                            setNewPhoto(null);
                          } else {
                            alert(result.message || "Upload failed");
                          }
                        } catch {
                          alert("Upload failed");
                        } finally {
                          setUploading(false);
                        }
                      }}
                    >
                      {uploading ? "Uploading..." : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );

}

function DetailRow({ label, value }) {
  return (
    <div className="detail-row">
      <span className="detail-label">{label}</span>
      <span className="detail-value">{value || "-"}</span>
    </div>
  );
}
